const THRESHOLDS = { '10+0': [60000], '30+0': [300000, 60000], '12h': [3600000, 300000, 60000] };
function warningThresholds(preset) { return THRESHOLDS[preset] || []; }
function dueClockWarning(preset, remainingMs, seen = []) {
  if (!Number.isFinite(remainingMs) || remainingMs <= 0) return null;
  // A resumed client/server can miss several thresholds. Emit only the most urgent.
  const due = warningThresholds(preset).filter(ms => remainingMs <= ms && !seen.includes(ms));
  return due.length ? Math.min(...due) : null;
}
function warningText(ms) { return ms === 3600000 ? 'Son 1 saatin kaldı.' : ms === 300000 ? 'Son 5 dakikan kaldı.' : 'Son 1 dakikan kaldı.'; }
module.exports = { warningThresholds, dueClockWarning, warningText };
